import React, { useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import queryString from "query-string";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import { Color } from "../../../components/Form/Button";
import TaskService from "Services/task.service";
import { AppPageCardInform } from "Components/AppPageCardInform";

type AcceptInvitePayload = {
  token: string;
};

export const AcceptedTaskInvite = () => {
  const history = useHistory();
  const { t: translate } = useTranslation();

  // eslint-disable-next-line no-restricted-globals
  const parsed: { token?: string } = queryString.parse(location.search);

  const [token, setToken] = useState<string>("");

  const {
    mutate: acceptInvite,
    isLoading: isLoadingInviteAgent,
    isError,
  } = useMutation(["task.invite.agent"], (payload: AcceptInvitePayload) =>
    TaskService.acceptOrRejectAgentInvite(payload.token, "accept")
  );

  const handleCloseWindow = () => {
    window.close();
  };

  const getContentProps = () => {
    if (isLoadingInviteAgent) return {
      title: translate("loading"),
    };

    if (isError) {
      return {
        title: translate("invalidLink"),
        content: translate("theInviteLinkIsBroken"),
        actionText: translate("closeWindow"),
        onActionClick: handleCloseWindow,
        actionColor: Color.SECONDARY_DARK
      };
    }

    return {
      icon: <CheckCircleIcon sx={{ color: "#E6EEF6", fontSize: 72 }} />,
      title: "Order successfully accepted.",
      content: "Soon you'll receive an email with further details. Have a great day! You can safely close this window now.",
      actionText: translate("closeWindow"),
      onActionClick: handleCloseWindow,
      actionColor: Color.SECONDARY_DARK
    };
  };

  useEffect(() => {
    if (parsed?.token) {
      setToken(parsed.token);
    } else {
      history.replace("/");
    }
  }, [parsed]);

  useEffect(() => {
    if (token) {
      acceptInvite({
        token,
      });
    }
  }, [token]);

  return <AppPageCardInform {...getContentProps()} />;
};